<script lang="ts">
import { defineComponent } from "vue";
import KlereoBanner from "@/shared/components/KlereoBanner.vue";
import PromiseWrapper from "@/shared/components/PromiseWrapper.vue";
import { apiService } from "@/services/services";
import { Nullable } from "@/models/nullable.type";
import buildMarkers, { PoolMarker } from "@/features/map/buildMarkers";
import KlereoIcon from "@/shared/components/KlereoIcon.vue";
import { injectToken } from "@/shared/utils/injection";

export default defineComponent({
  ...injectToken,
  components: {
    KlereoIcon,
    PromiseWrapper,
    KlereoBanner,
  },
  data() {
    return {
      tooltip: null as Nullable<number>,
      markers: [] as PoolMarker[],
      promise: apiService.getAddresses().then((response) => {
        // @ts-ignore
        this.markers = buildMarkers(response);
      }),
    };
  },
});
</script>

<template>
  <div
    style="
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: 0 -1.25em -1.25em -1.25em;
    "
  >
    <div class="flex flex-col h-full">
      <klereo-banner
        class="px-5"
        @left="$emit('openSidebar')"
        left-icon="klereo"
        left-class="lg:hidden"
        :title="$t('PoolMap')"
        ><div class="hidden lg:flex items-center">
          <router-link :to="lastPool ? `/pool/${lastPool.idSystem}` : '/'"
            ><klereo-icon name="arrow-left" class="w-[27px]"
          /></router-link></div
      ></klereo-banner>

      <div class="flex-grow relative">
        <promise-wrapper :promise="promise">
          <GMapMap
            :center="{ lat: 46.71109, lng: 1.7191036 }"
            :zoom="6"
            style="position: absolute; top: 0; right: 0; bottom: 0; left: 0"
          >
            <GMapMarker
              v-for="(marker, idx) in markers"
              :key="idx"
              :icon="marker.icon"
              :position="{ lat: marker.latitude, lng: marker.longitude }"
              :zIndex="marker.zIndex"
              @click="tooltip = idx"
            >
              <GMapInfoWindow :opened="tooltip === idx">
                <div>
                  <strong>{{ marker.poolName }}</strong
                  ><br />
                  {{ marker.message }}
                </div>
              </GMapInfoWindow></GMapMarker
            >
          </GMapMap>
        </promise-wrapper>
      </div>
    </div>
  </div>
</template>
